export const colors = {
  xenieBlue: "#354255",
  xenieBlueLight: "rgba(53, 66, 85, 0.85)",
  itemSelectedBackground: "#556275",
  backgroundGrey: "#EEEEEE",
  colorWhite: "#ffffff",
  fontLightBlack: "#404040",
  optionHOverBlue: "rgba(136,148,219,0.3)",
  colorLightGrey: "#909090",
  lightBlack: "#707070",
  labelLightGrey: "#a7a7a7",
  errorRedBorder: "#F50B00",
  boxShadowSlider: "rgba(179, 179, 179, 0.68)",
  buttonDarkGrey: "#4a4a4a",
  openTicketBackground: "#fa9418",
  inProgressTicketBackground: "#E3E109",
  closedTicketBackground: "#0AFD5E",
  escalatedTicketBackground: "#E30928",
  awaitingTicketBackground: "#6114FD",
  resolvedTicketBackground: "#98FF00",
  borderGray: "rgba(222, 228, 232, 0.5)",
  previewHeaderText: "#656565",
  colorLightBorder: "#c5c5c5",
  filterButtonBackground: "#647CA1",
};
